const PHONE_PATTERN = /^\+?[0-9()\s-]{8,20}$/;

let countriesPromise = null;
const countryPickers = [];

function getFormMessages(form) {
    const data = form ? form.dataset : {};
    return {
        requiredField: data.msgRequired || "",
        emailInvalid: data.msgEmailInvalid || "",
        phoneInvalid: data.msgPhoneInvalid || "",
        loadingCountries: data.msgCountryLoading || "",
        loadCountriesError: data.msgCountryError || "",
        noCountries: data.msgCountryNone || "",
    };
}

function extractCountries(payload) {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.data?.items)) return payload.data.items;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.result?.items)) return payload.result.items;
    return [];
}

async function getCountries() {
    if (!countriesPromise) {
        countriesPromise = fetch("/api/catalog-countries?all=true", { method: "GET" })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Countries catalog request failed with status ${response.status}`);
                }
                return response.json();
            })
            .then((payload) => {
                return extractCountries(payload)
                    .filter((country) => country && country.name)
                    .filter((country) => country.enabled !== false && country.deleted !== true)
                    .sort((a, b) => a.name.localeCompare(b.name));
            });
    }

    return countriesPromise;
}

function closestFieldContainer(field) {
    return field.closest(".website-request-demo__field, .website-contact-sales__field");
}

function getFieldChrome(field) {
    if (field.matches("textarea")) return field;
    return field.closest(".website-request-demo__input-wrap, .website-contact-sales__input-wrap");
}

function setFieldError(field, message) {
    const container = closestFieldContainer(field);
    if (!container) return;

    const chrome = getFieldChrome(field);
    if (chrome) chrome.classList.add("is-invalid");

    let error = container.querySelector("[data-field-error]");
    if (!error) {
        error = document.createElement("p");
        error.className = "website-form-error";
        error.dataset.fieldError = "true";
        container.appendChild(error);
    }

    error.textContent = message;
}

function clearFieldError(field) {
    const container = closestFieldContainer(field);
    if (!container) return;

    const chrome = getFieldChrome(field);
    if (chrome) chrome.classList.remove("is-invalid");

    const error = container.querySelector("[data-field-error]");
    if (error) error.remove();
}

function validateField(field, messages) {
    const rawValue = typeof field.value === "string" ? field.value : "";
    const value = rawValue.trim();

    if (field.required && !value) {
        setFieldError(field, messages.requiredField);
        return false;
    }

    if (field.name === "email" && value && field.validity.typeMismatch) {
        setFieldError(field, messages.emailInvalid);
        return false;
    }

    if (field.name === "phone" && value && !PHONE_PATTERN.test(value)) {
        setFieldError(field, messages.phoneInvalid);
        return false;
    }

    clearFieldError(field);
    return true;
}

function applyFormValidation(form) {
    form.setAttribute("novalidate", "novalidate");
    const messages = getFormMessages(form);

    const fields = Array.from(
        form.querySelectorAll("input[name='name'], input[name='email'], input[name='phone'], input[name='country'], input[name='company'], textarea[name='message']")
    );

    fields.forEach((field) => {
        field.addEventListener("input", () => {
            if (field.dataset.touched === "true") validateField(field, messages);
        });

        field.addEventListener("blur", () => {
            field.dataset.touched = "true";
            validateField(field, messages);
        });
    });

    form.addEventListener("submit", (event) => {
        let firstInvalid = null;

        fields.forEach((field) => {
            field.dataset.touched = "true";
            const isValid = validateField(field, messages);
            if (!isValid && !firstInvalid) firstInvalid = field;
        });

        if (firstInvalid) {
            event.preventDefault();
            firstInvalid.focus();
        }
    });
}

function renderCountryStatus(dropdown, text) {
    dropdown.innerHTML = "";
    const row = document.createElement("button");
    row.type = "button";
    row.className = "website-form-country-option";
    row.disabled = true;
    row.textContent = text;
    dropdown.appendChild(row);
}

function renderCountryOptions(picker, countries) {
    picker.dropdown.innerHTML = "";

    if (!countries.length) {
        renderCountryStatus(picker.dropdown, picker.messages.noCountries);
        return;
    }

    countries.forEach((country) => {
        const option = document.createElement("button");
        option.type = "button";
        option.className = "website-form-country-option";
        option.dataset.countryValue = country.name;
        option.textContent = country.name;
        option.addEventListener("click", () => {
            picker.input.value = country.name;
            picker.input.dataset.touched = "true";
            validateField(picker.input, picker.messages);
            closeCountryPicker(picker);
        });
        picker.dropdown.appendChild(option);
    });
}

function filterCountries(picker) {
    const query = picker.input.value.trim().toLowerCase();
    const filtered = picker.countries.filter((country) => country.name.toLowerCase().includes(query));
    renderCountryOptions(picker, filtered);
}

function openCountryPicker(picker) {
    picker.element.classList.add("is-open");
    picker.dropdown.classList.remove("is-hidden");

    if (!picker.loaded && !picker.loadError) {
        renderCountryStatus(picker.dropdown, picker.messages.loadingCountries);
        return;
    }

    if (picker.loadError) {
        renderCountryStatus(picker.dropdown, picker.messages.loadCountriesError);
        return;
    }

    filterCountries(picker);
}

function closeCountryPicker(picker) {
    picker.element.classList.remove("is-open");
    picker.dropdown.classList.add("is-hidden");
}

function setupCountryPicker(input) {
    const pickerElement = input.closest("[data-country-picker]");
    if (!pickerElement) return;

    const dropdown = pickerElement.querySelector("[data-country-dropdown='true']");
    const toggle = pickerElement.querySelector("[data-country-toggle='true']");
    if (!dropdown || !toggle) return;

    const form = input.closest("form");
    const messages = getFormMessages(form);

    const picker = {
        element: pickerElement,
        input,
        dropdown,
        toggle,
        countries: [],
        loaded: false,
        loadError: false,
        messages,
    };

    countryPickers.push(picker);

    input.addEventListener("focus", () => openCountryPicker(picker));
    input.addEventListener("click", () => openCountryPicker(picker));
    input.addEventListener("input", () => openCountryPicker(picker));

    toggle.addEventListener("click", (event) => {
        event.preventDefault();
        if (picker.element.classList.contains("is-open")) {
            closeCountryPicker(picker);
        } else {
            input.focus();
            openCountryPicker(picker);
        }
    });

    input.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeCountryPicker(picker);
        }
    });

    renderCountryStatus(dropdown, messages.loadingCountries);
}

function closeCountryPickersFromOutside(event) {
    countryPickers.forEach((picker) => {
        if (!picker.element.contains(event.target)) {
            closeCountryPicker(picker);
        }
    });
}

async function initCountryPickers() {
    const countryInputs = Array.from(document.querySelectorAll("input[name='country'][data-country-catalog='true']"));
    if (!countryInputs.length) return;

    countryInputs.forEach((input) => setupCountryPicker(input));

    document.addEventListener("click", closeCountryPickersFromOutside);

    try {
        const countries = await getCountries();
        countryPickers.forEach((picker) => {
            picker.countries = countries;
            picker.loaded = true;

            if (picker.element.classList.contains("is-open")) {
                filterCountries(picker);
            }
        });
    } catch {
        countryPickers.forEach((picker) => {
            picker.loadError = true;
            picker.loaded = false;

            if (picker.element.classList.contains("is-open")) {
                renderCountryStatus(picker.dropdown, picker.messages.loadCountriesError);
            }
        });
    }
}

function initWebsiteForms() {
    const forms = document.querySelectorAll(".website-request-demo__form, .website-contact-sales__form");
    forms.forEach((form) => applyFormValidation(form));
    initCountryPickers();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWebsiteForms);
} else {
    initWebsiteForms();
}
